<template>
  <div class="advanced-certification">
    <certification-header :title="title" :txt="txt"></certification-header>
    <div v-if="step===1" class="border-1px advance-check">
      <check-address :data="r" :status="status" ref="checkAddress" @success="init"></check-address>
      <check-job :data="e" :status="status" ref="checkJob"></check-job>
    </div>
    <div class="commit text-center">
      <v-btn
        class="commit-btn"
        depressed
        :disabled="disable"
        :loading="committing"
        @click="commit"
      >{{$t('actions.submit')}}</v-btn>
    </div>
    <check-result v-if="step===2" :status="status"></check-result>
  </div>
</template>

<script>
import CertificationHeader from '../CertificationHeader/CertificationHeader';
import CheckAddress from '../CheckAddress/CheckAddress';
import CheckJob from '../CheckJob/CheckJob';
import CheckResult from '../CheckResult/CheckResult';
import tool from '@/common/js/tool';
import { seniorCertificationApi } from '@/api/user/seniorCertification';
import { mapActions } from 'vuex';
import { actionTypes } from '@/store/action-types';

export default {
  name: 'advanced-certification',
  components: {
    'check-result': CheckResult,
    'certification-header': CertificationHeader,
    'check-address': CheckAddress,
    'check-job': CheckJob
  },
  data() {
    return {
      title: this.$t('advanced.lvl2Verf'),
      txt: this.$t('labels.acc.advKyc'),
      step: 2,
      committing: false,
      r: {},
      e: {},
      status: 0,
      disable: false
    };
  },
  props: {},
  watch: {
    $route: {
      handler() {
        this.init();
      }
    }
  },
  computed: {},
  created() {
    this.init();
  },
  mounted() {},
  destroyed() {},
  methods: {
    ...mapActions([actionTypes.GET_USERINFO_ACTION]),
    init() {
      let obj = tool.urljson(window.location.href);
      this.step = +obj.step;
      this.$forceUpdate();
      seniorCertificationApi.getSeniorCertificationInfo().then(res => {
        let data = res.data;
        this.status = data.advancedAuthStatus;
        if (this.status == 0 /* pending */ || this.status == 1 /* success */) {
          this.disable = true;
        }
        if (!this.isUndefinedOrNullOrEmpty(data.r)) {
          this.r = data.r;
          if (!this.isUndefinedOrNullOrEmpty(this.r.countryCode)) {
            this.r.countryCode = this.r.countryCode.toLowerCase();
          }
        }

        if (!this.isUndefinedOrNullOrEmpty(data.e)) {
          this.e = data.e;
          if (!this.isUndefinedOrNullOrEmpty(this.e.employerCountryCode)) {
            this.e.employerCountryCode = this.e.employerCountryCode.toLowerCase();
          }
        }
      });
    },
    commit() {
      if (!this.$refs.checkAddress.form.countryCode || !this.$refs.checkJob.form.employerCountryCode) {
        this.errorNotify(this.$t('v.advance.submit.error'));
        return;
      }
      this.$refs.checkAddress.save().then(result => {
        if (result) {
          this.$refs.checkJob
            .save()
            .then()
            .then(result => {
              if (result) {
                seniorCertificationApi.submitAdvanceCertification().then(res => {
                  this.successNotify(this.$t('v.advance.submit.success'));
                  this.GET_USERINFO_ACTION();
                  this.init();
                });
              }
            });
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.advance-check {
  margin-top: 20px;
  padding-left: 30px;
}

.commit {
  text-align: center;
  margin-top: 30px;

  &-btn {
    width: 180px;
    background-color: #7b9af4 !important;
    color: #fff;
  }
}
</style>
